var cov_1y2v5b4a86 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Modal/context.tsx",
      hash = "dd52f7fe834e46dfcf2304123046d0c0c7f16ca9",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Modal/context.tsx",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 16
        },
        end: {
          line: 4,
          column: 38
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 7,
          column: 40
        }
      },
      "2": {
        start: {
          line: 9,
          column: 18
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "3": {
        start: {
          line: 9,
          column: 75
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "4": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 17,
          column: 21
        }
      },
      "5": {
        start: {
          line: 14,
          column: 17
        },
        end: {
          line: 14,
          column: 116
        }
      },
      "6": {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 31
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 18
          },
          end: {
            line: 9,
            column: 19
          }
        },
        loc: {
          start: {
            line: 9,
            column: 75
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 9,
            column: 75
          },
          end: {
            line: 9,
            column: 76
          }
        },
        loc: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 17,
            column: 21
          }
        },
        line: 12
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 13,
            column: 5
          },
          end: {
            line: 13,
            column: 6
          }
        },
        loc: {
          start: {
            line: 13,
            column: 14
          },
          end: {
            line: 16,
            column: 5
          }
        },
        line: 13
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 14,
            column: 42
          },
          end: {
            line: 14,
            column: 115
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 14,
            column: 42
          },
          end: {
            line: 14,
            column: 47
          }
        }, {
          start: {
            line: 14,
            column: 51
          },
          end: {
            line: 14,
            column: 65
          }
        }, {
          start: {
            line: 14,
            column: 69
          },
          end: {
            line: 14,
            column: 95
          }
        }, {
          start: {
            line: 14,
            column: 99
          },
          end: {
            line: 14,
            column: 115
          }
        }],
        line: 14
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _this = this,
    _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Modal/context.tsx";

import React from 'react';
import createReactContext from '../context';
var context = (cov_1y2v5b4a86.s[0]++, createReactContext({})); // eslint-disable-next-line

export var Provider = (cov_1y2v5b4a86.s[1]++, context.Provider);
cov_1y2v5b4a86.s[2]++;

var consumer = function consumer(Origin) {
  cov_1y2v5b4a86.f[0]++;
  cov_1y2v5b4a86.s[3]++;
  return function (props) {
    cov_1y2v5b4a86.f[1]++;
    cov_1y2v5b4a86.s[4]++;
    return (
      /*#__PURE__*/
      React.createElement(context.Consumer, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 12,
          columnNumber: 3
        }
      }, function (value) {
        cov_1y2v5b4a86.f[2]++;
        var mp = (cov_1y2v5b4a86.s[5]++, Object.assign({}, props, (cov_1y2v5b4a86.b[0][0]++, value) && (cov_1y2v5b4a86.b[0][1]++, props.absolute) && (cov_1y2v5b4a86.b[0][2]++, props.zIndex === undefined) && (cov_1y2v5b4a86.b[0][3]++, {
          zIndex: 1051
        })));
        cov_1y2v5b4a86.s[6]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, mp, {
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 15,
              columnNumber: 14
            }
          }))
        );
      })
    );
  };
};

export default consumer;